<template>
  <div>
    <img :src="imgurl" class="leftImg" @click="show()" />
     <!-- 图片查看 -->
        <viewer :images="images"
                @inited="inited"
                class="viewer" ref="viewer"
        >
        <template slot-scope="scope">
            <img v-for="src in scope.images" :src="src" :key="src">
            {{scope.options}}
        </template>
        </viewer>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";
export default {
  name: "leftImg",
  components: {
    Viewer
  },
  props: ["imgurl"],
  computed:{
      images(){
          return [this.imgurl];
      }
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    }
  }
};
</script>

<style scoped>
</style>